var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.$vuetify.breakpoint.smAndDown ? 'padding: 15% 5%' : 'padding: 6% 5%')},[_c('PageBreadcrumbs',{attrs:{"data":_vm.breadcrumbs}}),_c('vs-row',{attrs:{"justify":"center"}},[_c('h1',[_vm._v("Waist Coats")])]),_c('Products',{attrs:{"products":_vm.waistCoats}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }